<template>

    <div>

        <div class="genereted-row">

            <div class="genereted-row__line">

                <span>{{task.ProjectName}}</span>

                <span class="genereted-row__line-lang">

                    {{ task.Targetlanguage.LanguageName.split('(')[0] }} ({{ task.Targetlanguage.CountryISOCode }})

                    <img v-if="task.Targetlanguage.CountryISOCode" v-bind:src="'img/lang/' + task.Targetlanguage.CountryISOCode.toLowerCase() + '.png'" class="option__image">

                </span>

            </div>
            <div class="genereted-row__button" @click="toggleTask">
                <svg :class="['icon', { active: toggle }]">
                    <use xlink:href="/img/icons/icons-sprite.svg#icon-checkout"/>
                </svg>
            </div>
        </div>

        <transition name="fade">

            <div
                v-if="toggle"
                class="genereted-content"
            >
                <div class="information">
                    <div class="information__row">
                        <span class="name">Target language</span>
                        <span class="data">
                            <multiselect
                                v-model="task.Targetlanguage"
                                placeholder="Search or add a document type"
                                label="LanguageName"
                                track-by="ID"
                                :options="params.Languages"
                                :multiple="false"
                                v-validate="'required'"
                                name="title"
                                required
                                >
                                <template
                                    slot="singleLabel" slot-scope="props">
                                    <img v-if="props.option.CountryISOCode" v-bind:src="'img/lang/' + props.option.CountryISOCode.toLowerCase() + '.png'" class="option__image">
                                    <span class="option__desc">
                                        <span class="option__title">{{ props.option.LanguageName }}</span>
                                    </span>
                                </template>
                                <template slot="option" slot-scope="props">
                                    <img v-if="props.option.CountryISOCode" v-bind:src="'img/lang/' + props.option.CountryISOCode.toLowerCase() + '.png'" class="option__image">
                                    <span class="option__title">{{ props.option.LanguageName }}</span>
                                </template>
                            </multiselect>
                        </span>
                    </div>
                    <div class="information__row">
                        <span class="name">Deadline</span>
                        <span class="data">30.06.2018, 11:30</span>
                    </div>
                    <div class="information__row">
                        <span class="name">Files</span>
                        <span class="data">{{task.NumberOfDocuments}}</span>
                    </div>
                    <div class="information__row">
                        <span class="name">Words</span>
                        <span class="data">{{task.TotalWordCount}}</span>
                    </div>
                    <div class="information__row">
                        <span class="name">Attach files</span>
                        <div @click="showAttachFiles" class="data">
                            <span v-if="task.JobAttachmentFiles" style="cursor: pointer">{{task.JobAttachmentFiles.length}} file(s)</span>
                            <span v-else class="data">No files uploaded</span>
                            <svg class="icon">
                                <use :xlink:href="showFiles ? '/img/icons/icons-sprite.svg#icon-checkout_invert' : '/img/icons/icons-sprite.svg#icon-checkout'"/>
                            </svg>
                        </div>

                    </div>
                </div>
                <form
                    :class="hoverFormFile ? 'upload active' : 'upload'"
                    enctype="multipart/form-data"
                    @drop.prevent="addFileDrag($event)"
                    @dragover.prevent="hoverFormFile = true"
                    @dragleave.prevent="hoverFormFile = false"
                    v-on:change="addFile"
                    v-if="this.uploadedFile.length === 0"
                >
                    <label class="upload-area" :for="'report-file-input' + index">
                        <div class="upload-area-block">
                            <div class="upload-title">
                                <span class="icon"></span>
                            </div>
                            <div>
                                <p class="upload__text"><b>Drag & Drop</b><br>to upload<br> the reference material</p>
                                <input type="file" class="hide-input">
                                <div class="upload__btn"><b>Select the file(s)</b></div>
                            </div>
                        </div>

                    </label>
                    <input type="file" class="report-file-input" accept=".doc,.docx,.txt,.pdf,.jpg,.jpeg,.png"
                        v-validate="'ext:doc,docx,txt,pdf,jpg,jpeg,png'"
                        :id="'report-file-input' + index"
                        name="file"
                    />
                </form>
                <div class="comment" v-else>
                    <div class="comment-area">
                        <div class="comment-area__data">
                            <div><span class="icon"></span>{{this.uploadedFile.name}}</div>
                            <textarea placeholder="Any text..." v-model="comment" v-validate="'required'" name="comment" required></textarea>
                        </div>
                        <div class="comment-area__buttons">
                            <button
                                @click="pushFile"
                                type="button"
                                class="btn btn-blue"
                            >Send file</button>

                            <span class="delimiter">or</span>

                            <button
                                @click="clearFileArea"
                                type="button"
                                class="btn btn-onlytext"
                            >Cancel</button>
                        </div>
                    </div>
                </div>
            </div>

        </transition>

        <transition name="fade">

            <div v-if="task.JobAttachmentFiles && showFiles" class="genereted-files files">
                <div class="triangle triangle_bottom">
                    <div class="triangle_inside"></div>
                    <div class="triangle_outside"></div>
                </div>
                <div class="files-data">
                    <table>
                        <tr>
                            <th><div>name</div></th>
                            <th><div>extension</div></th>
                            <th><div>Description</div></th>
                        </tr>
                        <tr v-for="(file, index) in task.JobAttachmentFiles" :key="index">
                            <th><div><span>{{index+1}}.</span>{{file.FileName.substring(0,file.FileName.indexOf("."))}}</div></th>
                            <th><div>{{file.FileName.substring(file.FileName.indexOf("."),file.FileName.length)}}</div></th>
                            <th>
                                <div @click="deleteAttachFile(index)">
                                    {{file.Description}}
                                </div>
                                <!-- <div>
                                    <svg width="12" height="15" viewBox="0 0 12 15" fill="none" xmlns="http://www.w3.org/2000/svg" class="svg-ic-del right" @click="deleteAttachFile(index)">
                                        <path d="M0.996443 14.6224C0.996443 14.831 1.16005 15 1.36188 15H10.6379C10.8397 15 11.0033 14.831 11.0033 14.6224V4.73684H0.996443V14.6224ZM8.05546 6.31579H9.42584V13.4919H8.05546V6.31579ZM5.31469 6.31579H6.68507V13.4919H5.31469V6.31579ZM2.57393 6.31579H3.94431V13.4919H2.57393V6.31579Z" fill="#C5C5C5"/>
                                        <path d="M9.08016 0.377568C9.08016 0.169037 8.91655 0 8.71472 0H3.28528C3.08345 0 2.91984 0.169037 2.91984 0.377568V2.20709H0.365435C0.163605 2.20709 0 2.37613 0 2.58466V3.53946C0 3.74797 0.163605 3.91702 0.365435 3.91702H11.6346C11.8364 3.91702 12 3.74797 12 3.53946V2.58466C12 2.37613 11.8364 2.20709 11.6346 2.20709H9.08016V0.377568ZM7.70978 2.12947H4.29022V1.41588H7.70978V2.12947Z" fill="#C5C5C5"/>
                                    </svg>
                                </div> -->
                            </th>
                        </tr>
                    </table>
                </div>

            </div>

        </transition>

    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import Vue from 'vue';
import VeeValidate from 'vee-validate';

Vue.use(VeeValidate, {
  aria: true,
});

export default {
  name: 'Task',
  props: ['task', 'index', 'params'],
  components: {
    Multiselect,
  },
  data () {
    return {
      toggle: false,
      uploadedFile: [],
      comment: '',
      files: [],
      showFiles: false,
      hoverFormFile: false,
    };
  },
  methods: {
    toggleTask () {
      this.toggle = !this.toggle;
    },
    showAttachFiles () {
      this.showFiles = !this.showFiles;
    },
    addFile (files = null) {
      var fileInput = files.type === 'change'
        ? files.target
        : files;
      this.$validator.validate().then((result) => {
        if (!result) {
          document.getElementById('report-file-input' + this.index).value = '';
          alert('We allow only doc, docx, txt, pdf, jpg, jped, png files');
        } else {
          if (fileInput.files[0].size >= 15000000) {
            alert(
              'Sorry, but max size of all files is 15MB. You have ' +
                            (fileInput.files[0].size) +
                            'B of free space'
            );
            document.getElementById('report-file-input' + this.index).value = '';
          } else {
            fileInput.files ? this.uploadedFile = fileInput.files[0] : this.uploadedFile = null;
          }
        }
      });
    },
    addFileDrag ($event) {
      const fileData = { files: $event.dataTransfer.files };
      this.addFile(fileData);
      this.hoverFormFile = false;
    },
    getJobAttachmentAsBase64 (file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    pushFile () {
      this.$validator.validate().then((result) => {
        if (!result) {
          alert('Please submit comment');
        } else {
          var base64Data = '';
          this.getJobAttachmentAsBase64(this.uploadedFile).then((data) => {
            base64Data = data;
            this.files.push({
              Base64File: base64Data,
              FileName: this.uploadedFile.name,
              Description: this.comment,
              Size: this.uploadedFile.size,
            });
            this.task.JobAttachmentFiles = this.files;
            this.uploadedFile = [];
            this.comment = '';
          }).catch((error) => {
            // console.log('something goes wrong', error);
          });
        }
      });
    },
    clearFileArea () {
      this.uploadedFile = [];
      this.comment = '';
    },
    deleteAttachFile (index) {
      this.task.JobAttachmentFiles.splice(index, 1);
    },
  },
};
</script>

<style lang="scss" src="./tasks.style.scss"></style>
